import { type Transaction } from "@finway-group/shared/lib/models"
import { type Reducer } from "redux"
import { TransactionTabTypeEnum } from "~Features/pages/transactions/TransactionsList"
import {
    type DeleteManyTransactionsAction,
    type FetchAllTransactionAction,
    type SetActiveTransactionTabAction,
    type SetShouldRefetchTransactionsAction,
    TransactionActionTypes,
    type TransactionActions,
} from "../actions/transaction/transactionTypes"

export interface TransactionState {
    items: Array<any>
    totalPages: number
    totalDocs: number
    shouldRefetch: boolean
    activeTransactionTab: TransactionTabTypeEnum
}

const initialState = {
    items: [],
    totalPages: 1,
    totalDocs: 0,
    shouldRefetch: false,
    activeTransactionTab: TransactionTabTypeEnum.OUTFLOW,
}

const fetchAllTransaction = (state: TransactionState, action: FetchAllTransactionAction): TransactionState => ({
    ...state,
    items: action.transactions,
    totalDocs: action.totalDocs,
    totalPages: action.totalPages,
})

const deleteManyTransactions = (state: TransactionState, { transactionIds }: DeleteManyTransactionsAction): TransactionState => {
    const remainingTransactions = state.items.filter((transaction: Transaction) => !transactionIds.includes(transaction.id))

    return {
        ...state,
        items: remainingTransactions,
    }
}

const setShouldRefetch = (state: TransactionState, action: SetShouldRefetchTransactionsAction): TransactionState => ({
    ...state,
    shouldRefetch: action.shouldRefetch,
})

const setActiveTransactionTab = (state: TransactionState, action: SetActiveTransactionTabAction): TransactionState => ({
    ...state,
    activeTransactionTab: action.activeTab,
})

export const transactionReducer: Reducer<TransactionState, TransactionActions> = (state = initialState, action) => {
    switch (action.type) {
        case TransactionActionTypes.SET_ACTIVE_TRANSACTION_TAB:
            return setActiveTransactionTab(state, action)
        case TransactionActionTypes.FETCH_ALL_TRANSACTION:
            return fetchAllTransaction(state, action)
        case TransactionActionTypes.SET_SHOULD_REFETCH_TRANSACTIONS:
            return setShouldRefetch(state, action)
        case TransactionActionTypes.DELETE_MANY_TRANSACTIONS:
            return deleteManyTransactions(state, action)
        default:
            return state
    }
}
